import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './plugins/elements.js'
import 'element-ui/lib/theme-chalk/display.css'

import './assets/css/beautifyTable.less'
import 'babel-polyfill'
import './assets/css/global.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import myVue from './assets/js/myVue'
import passwordCrypto from './assets/js/passwordCrypto'
import animated from 'animate.css'
import zkUI from './zkUI'

Vue.use(zkUI)
Vue.use(animated)
Vue.use(myVue)
Vue.use(passwordCrypto)

const wd = Vue.observable({
  h: document.body.offsetHeight,
  w: document.body.offsetWidth
})
Vue.prototype.$wd = wd
window.addEventListener('resize', () => {
  wd.h = document.body.offsetHeight
  wd.w = document.body.offsetWidth
})

Vue.config.productionTip = false

Vue.prototype.$baseURL = process.env.VUE_APP_BASE_API
axios.defaults.baseURL = process.env.VUE_APP_BASE_API

// 禁用生产提示消息
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$view = { span: 16, offset: 4 }

// 在request 拦截器中,展示进度条
axios.interceptors.request.use((request) => {
  NProgress.start()
  return request
})
// 在response 拦截器中,隐藏进度条
axios.interceptors.response.use(response => {
  NProgress.done()
  return response
}, error => {
  NProgress.done()
  if (error.response.status === 401) {
    window.location.href = error.response.data + window.location.href
  } else {
    Vue.prototype.$message.error(error.response.data)
  }
  // 继续抛出错误，让其他错误处理函数可以接收并处理
  return Promise.reject(error)
})

const removeAria = (el, binding) => {
  // 获取节点
  const ariaEls = el.querySelectorAll('.el-radio__original')
  ariaEls.forEach((item) => {
    item.removeAttribute('aria-hidden')
  })
}

Vue.directive('removeAria', removeAria)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
